export default __webpack_public_path__ + "assets/cr_pt.ce15b485.svg";